//
//  ImportUser.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { Button, Typography, Box } from "@mui/material";
import IsnLogo from "./component/IsnLogo";
import { useImportUser } from "./hooks/useImportUser";

const UserList = ({ title, users }: { title: string; users: string[] }) =>
  users.length > 0 ? (
    <Box sx={{ mt: 2, p: 2 }}>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body1" sx={{ whiteSpace: "pre" }} m={2}>
        {users.join("\n")}
      </Typography>
    </Box>
  ) : null;

const ImportUser = () => {
  const { csvData, result, importResult, handleFileChange, submitUserData } =
    useImportUser();

  return (
    <>
      <IsnLogo />
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box sx={{ width: "100%", maxWidth: 600, textAlign: "center", p: 2 }}>
          <Typography variant="h4" sx={{ m: 2 }}>
            ユーザ登録
          </Typography>
          <input
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            onClick={(e) => {
              (e.target as HTMLInputElement).value = "";
            }}
          />
          {csvData.length > 0 && (
            <Box sx={{ mt: 2, p: 2 }}>
              <Typography variant="h6">下記のユーザを登録します</Typography>
              <Typography variant="body1" sx={{ whiteSpace: "pre" }} m={2}>
                {csvData.map((user) => `${user.fitinsightUniqueId}`).join("\n")}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={submitUserData}
              >
                登録
              </Button>
            </Box>
          )}
          {importResult && (
            <Typography variant="body1" sx={{ mt: 2 }}>
              {importResult}
            </Typography>
          )}
          <UserList
            title="下記のユーザの登録に成功しました"
            users={result.success}
          />
          <UserList
            title="下記のユーザの登録に失敗しました"
            users={result.failed}
          />
        </Box>
      </Box>
    </>
  );
};

export default ImportUser;
